<template>
  <div class="stepper">
    <transition name="slide-fade">
      <div v-if="retirement.secondStepActive === 1">
        <div class="mb-3">
          <div class="row align-items-center">
            <div class="col-12 col-sm-4 form-group">
              <div class="row align-items-center ">
                <div class="col-auto">
                  <img
                    class="img-fluid icon"
                    src="../assets/images/money.png"
                  />
                </div>
                <div class="col label no-padding">
                  เงินเดือน (บาท/เดือน)
                  <img
                    class="img-fluid icon-info"
                    @click="getInfo('เงินเดือน')"
                    src="../assets/images/info.png"
                  />
                </div>
              </div>
            </div>
            <div class="col-12 col-sm form-group input-group-lg">
              <money
                v-bind="money"
                v-model="form.salary"
                class="form-control"
                placeholder="โปรดระบุ"
              ></money>

              <error-message :msg="errorMessage.salary"></error-message>
            </div>
          </div>
        </div>

        <div class="mb-3">
        <div class="row align-items-center">
          <div class="col-12 col-sm-4 form-group">
            <div class="label no-padding">
              อัตราการขึ้นเงินเดือน (%)
            </div>
          </div>

          <div class="col form-group input-group-lg">
            <money
              v-bind="money"
              v-model="form.salaryIncreasing"
              class="form-control"
              placeholder="โปรดระบุ"
              value="4"
            ></money>
            <error-message :msg="errorMessage.salaryIncreasing"></error-message>
          </div>
        </div>
        </div>


        <div class="mb-3">
          <div class="row align-items-center">
            <div class="col-12 col-sm-4 form-group">
              <div class="row align-items-center ">
                <div class="col-auto">
                  <img class="img-fluid icon" src="../assets/images/pig.png" />
                </div>
                <div class="col label no-padding">
                  เงินออม (บาท/เดือน)
                  <div>
                    <div class="txt-desc">
                      * ไม่รวมกองทุนสำรองเลี้ยงชีพ (PVD)
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12 col-sm form-group input-group-lg">
              <money
                v-bind="money"
                v-model="form.savingPerMonth"
                class="form-control"
                placeholder="โปรดระบุ"
              ></money>

              <error-message :msg="errorMessage.savingPerMonth"></error-message>
            </div>
          </div>
        </div>

        <div class="row justify-content-center">
          <div class="col-auto">
            <div class="button-accent" @click="nextStep(1)">ย้อนกลับ</div>
          </div>
          <div class="col-auto">
            <div class="button-yellow" @click="nextSubStep(2, 'next')">
              ถัดไป
            </div>
          </div>
        </div>
      </div>
    </transition>

    <transition name="slide-fade">
      <div v-if="retirement.secondStepActive === 2">
        <div class="mb-4 text-center">
          <div>สินทรัพย์ที่มีในปัจจุบัน</div>
        </div>

        <div class="mb-3">
          <div class="row align-items-center">
            <div class="col-12 col-sm-5">
              <div class="row align-items-center form-group">
                <div class="col-auto">
                  <img
                    class="img-fluid icon"
                    src="../assets/images/money.png"
                  />
                </div>
                <div class="col label no-padding">
                  เงินฝากและตลาดเงิน (บาท)
                  <img
                    class="img-fluid icon-info"
                    @click="getInfo('เงินฝากและตลาดเงิน')"
                    src="../assets/images/info.png"
                  />
                </div>
              </div>
            </div>

            <div class="col-12 col-sm form-group input-group-lg">
              <money
                v-bind="money"
                v-model="form.asset1"
                class="form-control"
                placeholder="โปรดระบุ"
              ></money>
            </div>
          </div>
        </div>

        <div class="mb-3">
          <div class="row align-items-center">
            <div class="col-12 col-sm-5">
              <div class="row align-items-center form-group">
                <div class="col-auto">
                  <img
                    class="img-fluid icon"
                    src="../assets/images/money_1.png"
                  />
                </div>
                <div class="col label no-padding">
                  ตราสารหนี้และกองทุนรวมตราสารหนี้ (บาท)
                  <img
                    class="img-fluid icon-info"
                    @click="getInfo('ตราสารหนี้และกองทุนรวมตราสารหนี้')"
                    src="../assets/images/info.png"
                  />
                </div>
              </div>
            </div>

            <div class="col-12 col-sm form-group input-group-lg">
              <money
                v-bind="money"
                v-model="form.asset2"
                class="form-control"
                placeholder="โปรดระบุ"
              ></money>
            </div>
          </div>
        </div>

        <div class="mb-3">
          <div class="row align-items-center">
            <div class="col-12 col-sm-5">
              <div class="row align-items-center form-group">
                <div class="col-auto">
                  <img
                    class="img-fluid icon"
                    src="../assets/images/growth.png"
                  />
                </div>
                <div class="col label no-padding">
                  หุ้นและกองทุนรวมไทย (บาท)
                  <img
                    class="img-fluid icon-info"
                    @click="getInfo('หุ้นและกองทุนรวมไทย')"
                    src="../assets/images/info.png"
                  />
                </div>
              </div>
            </div>

            <div class="col-12 col-sm form-group input-group-lg">
              <money
                v-bind="money"
                v-model="form.asset3"
                class="form-control"
                placeholder="โปรดระบุ"
              ></money>
            </div>
          </div>
        </div>

        <div class="mb-3">
          <div class="row align-items-center">
            <div class="col-12 col-sm-5">
              <div class="row align-items-center form-group">
                <div class="col-auto">
                  <img
                    class="img-fluid icon"
                    src="../assets/images/graph.png"
                  />
                </div>
                <div class="col label no-padding">
                  กองทุนผสม (บาท)
                  <img
                    class="img-fluid icon-info"
                    @click="getInfo('กองทุนผสม')"
                    src="../assets/images/info.png"
                  />
                </div>
              </div>
            </div>

            <div class="col-12 col-sm form-group input-group-lg">
              <money
                v-bind="money"
                v-model="form.asset4"
                class="form-control"
                placeholder="โปรดระบุ"
              ></money>
            </div>
          </div>
        </div>

        <div class="mb-3">
          <div class="row align-items-center">
            <div class="col-12 col-sm-5">
              <div class="row align-items-center form-group">
                <div class="col-auto">
                  <img class="img-fluid icon" src="../assets/images/REIT.png" />
                </div>
                <div class="col label no-padding">
                  กองทุนอสังหาริมทรัพย์/กอง REIT และกองทุนโครงสร้างพื้นฐาน (บาท)
                  <img
                    class="img-fluid icon-info"
                    @click="
                      getInfo(
                        'กองทุนอสังหาริมทรัพย์/กอง REIT และกองทุนโครงสร้างพื้นฐาน'
                      )
                    "
                    src="../assets/images/info.png"
                  />
                </div>
              </div>
            </div>

            <div class="col-12 col-sm form-group input-group-lg">
              <money
                v-bind="money"
                v-model="form.asset6"
                class="form-control"
                placeholder="โปรดระบุ"
              ></money>
            </div>
          </div>
        </div>

        <div class="mb-3">
          <div class="row align-items-center">
            <div class="col-12 col-sm-5">
              <div class="row align-items-center form-group">
                <div class="col-auto">
                  <img
                    class="img-fluid icon"
                    src="../assets/images/growth_1.png"
                  />
                </div>
                <div class="col label no-padding">
                  หุ้นและกองทุนรวมหุ้นต่างประเทศ (บาท)
                  <img
                    class="img-fluid icon-info"
                    @click="getInfo('หุ้นและกองทุนรวมหุ้นต่างประเทศ')"
                    src="../assets/images/info.png"
                  />

                  <div class="txt-desc">
                    * เงินที่จะได้รับทั้งหมดตลอดอายุของสัญญา
                  </div>
                </div>
              </div>
            </div>

            <div class="col-12 col-sm form-group input-group-lg">
              <money
                v-bind="money"
                v-model="form.asset5"
                class="form-control"
                placeholder="โปรดระบุ"
              ></money>
            </div>
          </div>
        </div>

        <div class="mb-3">
          <div class="row align-items-center">
            <div class="col-12 col-sm-5">
              <div class="row align-items-center form-group">
                <div class="col-auto">
                  <img class="img-fluid icon" src="../assets/images/gold.png" />
                </div>
                <div class="col label no-padding">
                  อื่นๆ (บาท) เช่น ทองคำ
                  <img
                    class="img-fluid icon-info"
                    @click="getInfo('อื่นๆ')"
                    src="../assets/images/info.png"
                  />
                </div>
              </div>
            </div>

            <div class="col-12 col-sm form-group input-group-lg">
              <money
                v-bind="money"
                v-model="form.asset7"
                class="form-control"
                placeholder="โปรดระบุ"
              ></money>
            </div>
          </div>
        </div>

        <div class="row justify-content-center">
          <div class="col-auto">
            <div class="button-accent" @click="nextSubStep(1)">ย้อนกลับ</div>
          </div>
          <div class="col-auto">
            <div class="button-yellow" @click="nextStep(3)">ถัดไป</div>
          </div>
        </div>
      </div>
    </transition>

    <dialog-normal
      :data="dataDialogNormal"
      :show="showDialogNormal"
      :dialog="dialog"
      @close="close"
    ></dialog-normal>
  </div>
</template>

<script>
import store from "../store";
import {
  SET_ACTIVE,
  SET_SUB_ACTIVE,
  SET_STEPPER_DATA,
} from "../store/actions.type";
import { mapState } from "vuex";
import * as validate from "validate.js";
import ErrorMessage from "./errorMessage";
import DialogNormal from "./dialogNormal";
import { assetsService } from "../services/assets";



export default {
  name: "StepperSecond",
  components: { DialogNormal, ErrorMessage },
  computed: mapState({
    retirement: (state) => state.retirement,
    form: (state) => state.retirement.data.second,
  }),
  data: () => ({
    errorMessage: {},
    dialog: {
      header: null,
      desc: null,
    },
    showDialogNormal: false,
    dataDialogNormal: {},

    money: {
      thousands: ",",
      precision: 0,
      masked: false,
    },
  }),
  methods: {
    nextSubStep(nextStep, direction) {
      if (direction === "next") {
        let errorMessage = this.validateForm(nextStep, this.form);

        if (errorMessage) {
          return (this.errorMessage = errorMessage);
        }
      }

      
      

      this.errorMessage = {};
      store.dispatch(SET_SUB_ACTIVE, {
        key: "secondStepActive",
        step: nextStep,
      });
    },
    nextStep(step) {
      store.dispatch(SET_ACTIVE, step);
      store.dispatch(SET_STEPPER_DATA, { key: "second", data: this.form });
    },

    getInfo(type) {
      let data = assetsService.getAssetsInfo(type);
      if (!data) return;

      this.showDialogNormal = true;
      this.dialog.message = `<div class="text-center md-display-1 mb-2 txt-gray"> ${
        data.name
      } </div>
                               <div class="md-title mb-3 txt-gray"> ${
                                 data.desc
                               }</div>
                               <div class="md-title txt-navy"> ${
                                 data.return
                                   ? "ผลตอบเเทน : " + data.return + "% ต่อปี"
                                   : ""
                               }</div>`;
    },

    close() {
      this.showDialogNormal = false;
    },

    validateForm(nextStep, data) {
      let errMessageList = null;
      let validateRule = {};

      validateRule = {
        salary: {
          presence: {
            allowEmpty: false,
            message: "^โปรดระบุ: เงินเดือน",
          },
          numericality: {
            greaterThan: 0,
            message: "^กรุณากรอกจำนวนเงินเดือน",
          },
        },
        salaryIncreasing: {
          presence: {
            allowEmpty: false,
            message: "^โปรดระบุ: อัตราการขึ้นเงินเดือน",
          },
          numericality: {
             greaterThanOrEqualTo: 0,
             lessThanOrEqualTo: 10,
             message: "^กรุณากรอกจำนวนอัตราการขึ้นเงินเดือน 0-10%"
          },
        },
        savingPerMonth: {
          presence: {
            allowEmpty: false,
            message: "^โปรดระบุ: เงินออม",
          },
          numericality: {
            greaterThan: 0,
            lessThanOrEqualTo: parseFloat(data.salary),
          },
        },
      };

      // set data to validate
      errMessageList = validate(
        {
          salary: data.salary,
          salaryIncreasing:data.salaryIncreasing,
          savingPerMonth: data.savingPerMonth,
        },
        validateRule
      );

      if (errMessageList) {
        const error = {};
        for (const [key, value] of Object.entries(errMessageList)) {
          let message = value[0];

          // custom message
          if (
            message.includes("Saving per month must be less than or equal to")
          ) {
            message = "กรุณากรอกจำนวนเงินออมน้อยกว่าเงินเดือน";
          } else if (
            message.includes("Saving per month must be greater than")
          ) {
            message = "กรุณากรอกจำนวนเงินออม";
          }

          error[key] = message;
        }
        return error;
      } else {
        return false;
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import "../assets/css/colors";

::-webkit-input-placeholder {
  text-align: center;
}

:-moz-placeholder {
  /* Firefox 18- */
  text-align: center;
}

::-moz-placeholder {
  /* Firefox 19+ */
  text-align: center;
}

:-ms-input-placeholder {
  text-align: center;
}
</style>
